import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import styles from '@src/styles/base/collapse.scss';

export default class Collapse extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            expanded: false,
        };
    }

    static get propTypes() {

        return {
            anchor: PropTypes.any,
            children: PropTypes.any,
        };
    }

    render() {

        const { anchor, children } = this.props;

        return (
            <div className={ css('collapse', styles) } aria-expanded={ this.state.expanded }>

                {/* title */}
                <div className={ css('collapse__title', styles) } onClick={ () => this.handleClick() }>
                    <div>{ anchor }</div>
                    <div className={ css('collapse__icon', styles) }>
                        { this.renderIcon() }
                    </div>
                </div>

                {/* body */}
                <div className={ css('collapse__body', styles) }>{ children }</div>

            </div>
        );
    }

    renderIcon() {

        return (
            <svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path fillRule='evenodd' clipRule='evenodd' d='M0.862254 0.528606C1.1226 0.268256 1.54471 0.268256 1.80506 0.528606L6.00033 4.72387L10.1956 0.528606C10.4559 0.268256 10.878 0.268256 11.1384 0.528606C11.3987 0.788955 11.3987 1.21107 11.1384 1.47141L6.47173 6.13808C6.21138 6.39843 5.78927 6.39843 5.52892 6.13808L0.862254 1.47141C0.601905 1.21107 0.601905 0.788955 0.862254 0.528606Z' fill='#87919C'/>
            </svg>
        );
    }

    handleClick() {

        const { expanded } = this.state;
        this.setState({ expanded: !expanded });
    }

}